import React from 'react'
import { useSelector } from 'react-redux'
import ErrorPage from './Pages/ErrorPage'

const ProtectedRoute = ({ children, access = [], redirectTo = '/login' }) => {
  const { adminLogin } = useSelector(state => state.auth)

  const userType = adminLogin ? 'admin' : null

  const hasAccess = access.includes(userType)

  if (!hasAccess) {
    return <ErrorPage status={403} />
  }

  return <>{children}</>
}

export default ProtectedRoute
